export default "__VITE_ASSET__7c2d8bf0__"